module.exports = __webpack_public_path__ + "static/media/1_1nam.d4cf1792.png";